import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { reviews } from '../data/mockData';

export const Reviews = () => {
  return (
    <section id="reviews" className="py-24 bg-white relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-16">
          <h2 className="text-4xl font-black text-[#0a192f] mb-4 uppercase tracking-tight">Lineup Chatter</h2>
          <div className="w-24 h-1 bg-[#93e9be] mx-auto mb-6 rounded-full"></div>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">Don't just take our word for it. Hear from the community.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <motion.div 
              key={review.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="bg-[#f8fafc] p-8 rounded-tr-[3rem] rounded-bl-[3rem] rounded-tl-lg rounded-br-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow relative"
            >
              <SafeIcon name="MessageSquare" className="absolute top-6 right-6 h-8 w-8 text-[#93e9be] opacity-30" />
              
              <div className="flex mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <SafeIcon key={i} name="Star" className="h-5 w-5 text-[#ff7f50] fill-current" />
                ))}
              </div>
              
              <p className="text-gray-700 mb-6 italic leading-relaxed">"{review.text}"</p>
              
              <div className="flex items-center">
                <div className="h-10 w-10 rounded-full bg-[#0a192f] flex items-center justify-center text-white font-bold text-lg mr-4">
                  {review.name.charAt(0)}
                </div>
                <div>
                  <h4 className="font-bold text-[#0a192f]">{review.name}</h4>
                  <p className="text-xs text-gray-500 uppercase tracking-wider">{review.location}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};